import { Link } from 'react-router-dom'
import { Home, Search } from 'lucide-react'
import UiButton from '../components/ui/UiButton'

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-12">
      <div className="text-center max-w-md">
        <h1 className="font-climate text-6xl md:text-8xl text-brand-blue mb-4">
          404
        </h1>
        <h2 className="font-climate text-2xl md:text-3xl text-brand-blue mb-4">
          Nie znaleziono strony
        </h2>
        <p className="text-brand-blue/80 mb-8">
          Wygląda na to, że strona, której szukasz, nie istnieje lub została
          przeniesiona.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/">
            <UiButton variant="gold" size="lg" icon={Home}>
              Wróć na stronę główną
            </UiButton>
          </Link>
          <Link to="/subscriptions/thematic">
            <UiButton variant="secondary" size="lg" icon={Search}>
              Przeglądaj ofertę
            </UiButton>
          </Link>
        </div>
      </div>
    </div>
  )
}
